import styled from 'styled-components';

export const CustomBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;

  > * {
    width: 100%;
    height: 100%;
  }
`;
